import { render, staticRenderFns } from "./OrderTeam.vue?vue&type=template&id=248c6687&scoped=true"
import script from "./OrderTeam.vue?vue&type=script&lang=js"
export * from "./OrderTeam.vue?vue&type=script&lang=js"
import style0 from "./OrderTeam.vue?vue&type=style&index=0&id=248c6687&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248c6687",
  null
  
)

export default component.exports